import jQuery from "jquery";

// Define & use jQuery on the global window object
Object.assign(window, { $: jQuery, jQuery });
